
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_npf3s_10",
  "with-toolbar": "awsui_with-toolbar_l0dv0_npf3s_44",
  "header": "awsui_header_l0dv0_npf3s_48",
  "list--with-icons": "awsui_list--with-icons_l0dv0_npf3s_61",
  "header-link": "awsui_header-link_l0dv0_npf3s_65",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_npf3s_76",
  "header-link-text": "awsui_header-link-text_l0dv0_npf3s_76",
  "header-logo": "awsui_header-logo_l0dv0_npf3s_81",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_npf3s_87",
  "items-control": "awsui_items-control_l0dv0_npf3s_92",
  "list-container": "awsui_list-container_l0dv0_npf3s_97",
  "divider-header": "awsui_divider-header_l0dv0_npf3s_105",
  "root--collapsed": "awsui_root--collapsed_l0dv0_npf3s_109",
  "list": "awsui_list_l0dv0_npf3s_61",
  "list-variant-root": "awsui_list-variant-root_l0dv0_npf3s_122",
  "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_npf3s_129",
  "list-variant-root--collapsed": "awsui_list-variant-root--collapsed_l0dv0_npf3s_132",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_npf3s_139",
  "list-variant-expandable-link-group--collapsed": "awsui_list-variant-expandable-link-group--collapsed_l0dv0_npf3s_145",
  "list-variant-section": "awsui_list-variant-section_l0dv0_npf3s_149",
  "list-variant-section--collapsed": "awsui_list-variant-section--collapsed_l0dv0_npf3s_152",
  "list-variant-link-group": "awsui_list-variant-link-group_l0dv0_npf3s_161",
  "list-variant-link-group--collapsed": "awsui_list-variant-link-group--collapsed_l0dv0_npf3s_177",
  "link-group-children": "awsui_link-group-children_l0dv0_npf3s_194",
  "link-group-children--collapsed": "awsui_link-group-children--collapsed_l0dv0_npf3s_211",
  "link-group-children-inner": "awsui_link-group-children-inner_l0dv0_npf3s_228",
  "link-group-children-inner--expanded": "awsui_link-group-children-inner--expanded_l0dv0_npf3s_247",
  "link-group-children-inner--settled": "awsui_link-group-children-inner--settled_l0dv0_npf3s_263",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_npf3s_267",
  "list-variant-section-group--collapsed": "awsui_list-variant-section-group--collapsed_l0dv0_npf3s_273",
  "list-item": "awsui_list-item_l0dv0_npf3s_277",
  "list-item--collapsed": "awsui_list-item--collapsed_l0dv0_npf3s_290",
  "list-item--link-with-info": "awsui_list-item--link-with-info_l0dv0_npf3s_296",
  "list-item--group": "awsui_list-item--group_l0dv0_npf3s_301",
  "section": "awsui_section_l0dv0_npf3s_301",
  "section-group": "awsui_section-group_l0dv0_npf3s_302",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_npf3s_307",
  "section--no-ident": "awsui_section--no-ident_l0dv0_npf3s_310",
  "section--expand-icon-end": "awsui_section--expand-icon-end_l0dv0_npf3s_310",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_npf3s_311",
  "expandable-link-group--expand-icon-end": "awsui_expandable-link-group--expand-icon-end_l0dv0_npf3s_312",
  "section--collapsed": "awsui_section--collapsed_l0dv0_npf3s_315",
  "expandable-link-group--collapsed": "awsui_expandable-link-group--collapsed_l0dv0_npf3s_316",
  "expandable-link-group--active": "awsui_expandable-link-group--active_l0dv0_npf3s_340",
  "item-icon": "awsui_item-icon_l0dv0_npf3s_344",
  "refresh": "awsui_refresh_l0dv0_npf3s_387",
  "section-header": "awsui_section-header_l0dv0_npf3s_438",
  "section-group-title": "awsui_section-group-title_l0dv0_npf3s_453",
  "section-group-title--collapsed": "awsui_section-group-title--collapsed_l0dv0_npf3s_474",
  "link": "awsui_link_l0dv0_npf3s_194",
  "link-active": "awsui_link-active_l0dv0_npf3s_532",
  "link--collapsed": "awsui_link--collapsed_l0dv0_npf3s_539",
  "header-link-active": "awsui_header-link-active_l0dv0_npf3s_659",
  "link-text-wrapper-content": "awsui_link-text-wrapper-content_l0dv0_npf3s_688",
  "link-text-wrapper": "awsui_link-text-wrapper_l0dv0_npf3s_688",
  "link-text-wrapper--collapsed": "awsui_link-text-wrapper--collapsed_l0dv0_npf3s_715",
  "label-text": "awsui_label-text_l0dv0_npf3s_733",
  "label-text--collapsed": "awsui_label-text--collapsed_l0dv0_npf3s_753",
  "info": "awsui_info_l0dv0_npf3s_772",
  "item-icon--collapsed": "awsui_item-icon--collapsed_l0dv0_npf3s_794",
  "external-icon": "awsui_external-icon_l0dv0_npf3s_798",
  "divider": "awsui_divider_l0dv0_npf3s_105",
  "divider-default": "awsui_divider-default_l0dv0_npf3s_806",
  "divider--collapsed": "awsui_divider--collapsed_l0dv0_npf3s_810"
};
  